<!-- 云果追朔服务服务 -->
<template>
<div class="site-content">
  <div class="site-content-banner search-banner">
    <img src="./../../assets/cyfw_banner_1.png"/>
    <div class="list-search-div">
      <div class="banner-search-1"><input type="text" name="site-search" class="search-input" v-model="keyWord" placeholder="输入二维溯源码，即可查询真伪"/><a @click="searchAct()" class="search-button">查询</a></div>
      <div class="banner-title-1">舌尖上的安全，从ID云果开始</div>
      <div class="banner-title-2">用互联网重新定义云果品质</div>
    </div>
  </div>
  <div class="site-content-page width-per-100 bg-style-1">
    <div class="content-row">
      <div class="content-col">
         <div class="banner-index-1">
              <div class="title-1">一份消费者看得懂的质量安全追溯报告</div>
              <div class="label-1">通过模型算法，关键点风控分析，由系统帮助消费者看报告，消费者用手机扫描二维码， 只要看一眼报告结论，就知没有任何安全风险、以及原产地</div>
         </div>
      </div>
    </div>
  </div>
  <div class="site-content-page width-per-100 bg-style-2">
    <div class="content-row">
      <div class="content-col">
        <div class="banner-index-2">
             <div class="title-1">让安全、品牌走进消费者心里</div>
             <div class="label-1">无论对于关注食安的政府、还是创造品牌的企业，在农产品上，没有比安全更深入人心的抓住安全，就是抓住消费者的心智</div>
        </div>
      </div>
    </div>
   </div>
   <div class="site-content-page width-per-100 bg-style-1">
     <div class="content-row">
       <div class="content-col">
          <div class="banner-index-3">
              <div class="title-1-1">关键点控制、智能化、标准化，让追溯变得简单、高效</div>
              <div class="label-1-1">无论对于关注食安的政府、还是创造品牌的企业，在农产品上，没有比安全更深入人心的抓住安全，就是抓住消费者的心智</div>
          </div>
          <div class="banner-index-4">
            <div class="banner-content-1">
              <div class="title-2">生产智能化、运输智能化让追溯变得简单</div>
              <div class="label-2">关于食品安全关键信息，在智能化生产软件大规模应用后就成为了数据沉淀，这些数据记录人、对象、操作方法、时间等，在广度、深度、精确度上都有保障，云果码就是把这些数据利用起来</div>
            </div>
          </div>
          <div class="banner-index-5">
            <div class="banner-content-1">
              <div class="title-2">线上交易</div>
              <div class="label-2">让上游下游数据完全贯通复杂的中间交易，是困扰追溯数据连续性的最大难题国家生猪市场线上交易，让数据连通、一对应成为可能，云果码就建立于在这样一个最重要的节点之上</div>
            </div>
          </div>
          <div class="banner-index-6">
            <div class="title-2">挑人挑企业的准入</div>
            <div class="label-2">准入才是保证质量安全的成败关键，云果码对种植企业与水果食品加工企业都有严苛的标准，无论是对规模大小、工艺规范的要求，还是风险亮红灯时的处罚</div>
          </div>
          <div class="banner-index-7">
            <div class="title-2">开放平台、让更多企业与平台加入</div>
            <div class="label-2">云果码系统是一个开放平台，它有一套行为逻辑与数据标准，只要达到要求，种植企业、水果食品加工企业内部的定制生产系统，包括运输平台，都可以顺利接入</div>
          </div>
       </div>
     </div>
   </div>

   <div class="site-content-page width-per-100 bg-style-2">
     <div class="content-row">
       <div class="content-col banner-flex-1">
         <div class="banner-index-8">
             <div class="title-3 title-3-1">真源码溯源云</div>
             <div class="label-3">溯源云扶贫平台，从源头保障产品的安全，让消费者更放心</div>
         </div>
         <div class="banner-index-8">
             <div class="title-3 title-3-2">智慧农业物联网</div>
             <div class="label-3">支持按需添加物联网模块：温度、海拔、湿度、风力、水质、土然、灌溉水源流量、水位等物联网模块支持自定义添加。</div>
         </div>
         <div class="banner-index-8">
              <div class="title-3 title-3-3">源头直播摄像机</div>
              <div class="label-3">自主研发，是安防监控也是网红农货营销工具打开手机，随时看基地以及顾客访问记录顾客留言。客户看得见的真源头直播。支持24小时直播，真实货源看得见。支持分享摄像机画面给亲人给客户。</div>
         </div>
         <div class="banner-index-8">
              <div class="title-3 title-3-4">地块管理</div>
              <div class="label-3">溯源云扶贫平台，从源头保障产品的安全，让消费者更放心</div>
         </div>
         <div class="banner-index-8">
              <div class="title-3 title-3-5">农业大数据</div>
              <div class="label-3">支持按需添加物联网模块：温度、海拔、湿度、风力、水质、土然、灌溉水源流量、水位等物联网模块支持自定义添加</div>
         </div>
         <div class="banner-index-8">
              <div class="title-3 title-3-6">防串货</div>
              <div class="label-3">自主研发，是安防监控也是网红农货营销工具打开手机，随时看基地以及顾客访问记录顾客留言。客户看得见的真源头直播。支持24小时直播，真实货源看得见。支持分享摄像机画面给亲人给客户</div>
         </div>
       </div>
     </div>
    </div>

</div>
</template>

<script>
import ColInfoList from '../block/ColInfoList'
import JrfwInfo1 from '../module/JrfwInfo1'
import JrfwInfo2 from '../module/JrfwInfo2'
export default {
  name: 'Cyfw03',
  components: {
    'col-info-list': ColInfoList,
  },
  data() {
    return {
      msg: 'Welcome to Your Vue.js App---template',
      infoBlock1:JrfwInfo1,
      infoBlock2:JrfwInfo2,
      infoPage1:{list:[],total:0},
      infoPage2:{list:[],total:0},
    }
  },
  methods:{
    //金融服务
    jrfw_Req(params){
          let that=this;
          params.p=1;
          //params.type="金融服务";
          let result={page:params};
          console.log('父页面查询参数：'+JSON.stringify(params));
          that.$dataApi.orgServiceLists(params).then(res =>{
          //console.log('请求Vue-axios结果：'+JSON.stringify(res))
          that.msg=res.msg;
          result.list= res.data.list;
          result.page.total=res.data.total;
          that.infoPage1=result;
          console.log('结束请求Vue-axios：'+JSON.stringify(result))
          });
    },
    //服务机构
    fwjg_Req(params){
          let that=this;
          let result={page:params};
          console.log('父页面查询参数：'+JSON.stringify(params));
          that.$dataApi.orgEnterpriseLists(params).then(res =>{
          //console.log('请求Vue-axios结果：'+JSON.stringify(res))
          that.msg=res.msg;
          result.list= res.data.list;
          result.page.total=res.data.total;
          that.infoPage2=result;
          console.log('结束请求Vue-axios：'+JSON.stringify(result))
          });
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1,
h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}
.width-per-100{
  width:100%;
}
.content-row{
  padding-top:0px;
}
.bg-style-1{
  background:#F7F7F7;
  //background:red;
}

.bg-style-2{
  background:#ffffff;
}
.content-row{
  width:1024px;
  margin:0 auto;
}
.content-row-c1{
  width:100%;
  background:#eee;
}

.content-row-c1 .content-block{
  width:1024px;
  margin:0 auto;
  background:#eee;
}

.search-banner{
  position:relative;
}

.list-search-div{
  position:absolute;
  width:640px;
  height:160px;
  padding-top:0px;
  top: calc(50% - 70px);
  left: calc(50% - 320px);
  z-index:999;
  //background:green;
  text-align:center;
}

.list-search-div .banner-search-1{
  position:relative;
  height:56px;
  padding:3px 3px 3px 3px;
  background:var(--color6);
  background-color:rgba(241,161,0,0.7);
}

.banner-search-1 .search-input {
  display: block;
  float: left;
  width: 534px;
  height: 50px;
  outline-style: none;
  border: 0px solid rgba(255,255,255,0.0);
  border-right: 0px;
  font-size: 14px;
  padding-left: 5px;
  background:#fff;
}

.banner-search-1 .search-button {
  display: block;
  float: left;
  width: 100px;
  height: 50px;
  text-decoration: none;
  border: 0px solid #fff;
  border-left: 0px solid #fff;
  background: #68352F;
  font-size: 12px;
  color:#ffffff;
  text-align: center;
  line-height:50px;
  letter-spacing:5px;
}

.search-button:hover{
  cursor: pointer;
}

.search-button:active{
  background:var(--color2);
  text-decoration:none;
}

.banner-title-1{
  position:relative;
  height:60px;
  color:#fff;
  letter-spacing:2px;
  font-size:18px;
  opacity:0.8;
  line-height:70px;
}

.banner-title-2{
  height:40px;
  color:#fff;
  font-size:14px;
  opacity:0.8;
  letter-spacing:2px;
  line-height:40px;
}

/**-------------*/
.title-1{
  position:relative;
  width:100%;
  font-size:20px;
  text-align:left;
  letter-spacing:2px;
  line-height:60px;
  color:#515151;
}

.label-1{
  position:relative;
  width:100%;
  font-size:12px;
  text-align:left;
  line-height:20px;
  color:#888888;
}

.title-1-1{
  position:relative;
  width:100%;
  font-size:20px;
  text-align:center;
  letter-spacing:2px;
  line-height:60px;
  color:#515151;
}

.label-1-1{
  position:relative;
  width:100%;
  font-size:12px;
  text-align:center;
  line-height:20px;
  color:#888888;
}

.title-2{
  position:relative;
  width:100%;
  padding:10% 80px 0px 80px;
  font-size:14px;
  font-weight:600;
  text-align:left;
  letter-spacing:2px;
  line-height:60px;
  color:#000;

}

.label-2{
  position:relative;
  width:100%;
  padding:0px 80px 0px 80px;
  font-size:12px;
  text-align:left;
  line-height:20px;
  color:#888888;
}

.title-3{
  position:relative;
  width:100%;
  height:100px;
  padding:0px;
  font-size:14px;
  font-weight:600;
  text-align:center;
  letter-spacing:2px;
  line-height:140px;
  color:#000;
  //background:red;

  background-size: auto 50px;
  background-repeat: no-repeat;
  background-position: center 0px;
}

.label-3{
  position:relative;
  width:100%;
  padding:0px;
  font-size:12px;
  text-align:center;
  line-height:20px;
  color:#888888;
}

.title-3-1{
  background-image:url(./../../assets/cyfw_index_4_1.png);
}
.title-3-2{
  background-image:url(./../../assets/cyfw_index_4_2.png);
}
.title-3-3{
  background-image:url(./../../assets/cyfw_index_4_3.png);
}
.title-3-4{
  background-image:url(./../../assets/cyfw_index_4_4.png);
}
.title-3-5{
  background-image:url(./../../assets/cyfw_index_4_5.png);
}
.title-3-6{
  background-image:url(./../../assets/cyfw_index_4_6.png);
}

.banner-content-1{
  width:100%;
  height:100%;
  background:#FFFFFF;
}

.banner-index-1{
  position:relative;
  width:100%;
  height:400px;
  padding:120px 10px 0px 440px;
  //background:yellow;
  background-image:url(./../../assets/cyfw_index_01.png);
  background-size: 400px auto;
  background-repeat: no-repeat;
  background-position: 0px center;
}

.banner-index-2{
  position:relative;
  width:100%;
  height:400px;
  padding:140px 10px 0px 440px;
  //background:yellow;
  background-image:url(./../../assets/cyfw_index_02.png);
  background-size: 400px auto;
  background-repeat: no-repeat;
  background-position: 0px 0px;
}

.banner-index-3{
  position:relative;
  width:100%;
  height:120px;
  padding:10px 10px 10px 10px;
  //background:yellow;
  text-align:center!important;
}

.banner-index-4{
  position:relative;
  width:100%;
  height:240px;
  padding:0px 0px 0px 50%;
  background:#1F3077;
  background-image:url(./../../assets/cyfw_index_3_1.png);
  background-size: 400px auto;
  background-repeat: no-repeat;
  background-position: calc(25% - 99px) center;
}

.banner-index-5{
  position:relative;
  width:100%;
  height:240px;
  padding:0px 50% 0px 0px;
  background:#1F3077;
  background-image:url(./../../assets/cyfw_index_3_2.png);
  background-size: 400px auto;
  background-repeat: no-repeat;
  background-position: calc(75% + 99px) center;
}

.banner-index-6{
  position:relative;
  float:left;
  width:49%;
  margin-top:2%;
  margin-bottom:3%;
  height:220px;
  padding:0px 0px 10px 0px;
  background:#fff;
}

.banner-index-7{
  position:relative;
  float:right;
  width:49%;
  margin-top:2%;
  margin-bottom:3%;
  height:220px;
  padding:0px 0px 10px 0px;
  background:#fff;
}

.banner-flex-1 {
  display: flex;
  flex-wrap: wrap;
  justify-content:space-between;
}

.banner-index-8{
  flex-grow:1;
  width:30%;
  padding:40px;
  background:#fff;
}
</style>



// WEBPACK FOOTER //
// src/components/page/Cyfw03.vue